import '../../../styles/_detailCard.scss';

/** The label above each section of the broker card ("Address:", "Email:", "Phone:"). */
export const CardSectionLabel = ({ children }: { children: React.ReactNode }) => {
    return <div className='brokerSelectorCardSectionLabel'>{children}</div>;
};
